module.exports = __webpack_public_path__ + "assets/img/xiangmu.3876e467.png";